// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__6CDZt","inner":"Form_inner__IgKPF","range":"Form_range__3Jb8e","name":"Form_name__1T-dg","actions":"Form_actions__1KaZR"};